<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neInfo' :neArr='netype' :select='neClick' name="selectNeTree"></NeList>
    </template>
    <template v-slot:right_view>
      <UETableMenu @methodEnum='methodEnum' @keywords='changeKeywords'></UETableMenu>
      <UETable ref="ueTable"></UETable>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import NeList from '../../components/common/NeList';
import UETableMenu from '../../components/ueConfig/UETableMenu';
import UETable from '../../components/ueConfig/UETable';

export default {
  name: 'UeListPage',
  components: {
    BasicLayout,
    NeList,
    UETableMenu,
    UETable
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('UE.neList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        name: this.$t('UE.ueTraffic')
      },
      netype: [
        3 // 'mme',
        // 4 // 'hss'
      ],
      ne: undefined
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'qry':
          this.$refs.ueTable.getGridUEData(this.ne);
          break;
        case 'detailQry':
          this.$refs.ueTable.getDetailUEData();
          break;
        default:
      }
    },
    changeKeywords(args) {
      this.$refs.ueTable.queryConditions.keywords = args;
    },
    neClick() {
      this.ne = this.$refs.neInfo.getNe().data;
      this.$refs.ueTable.getGridUEData(this.ne);
    }
  }
};
</script>

<style scoped>

</style>
